import axios from 'axios';

const API_URL = 'https://t8sexsj1d9.execute-api.us-east-1.amazonaws.com/prod/insights';

export const getInsightsForPortco = async (pitchbookId) => {
  try {
    const response = await axios.get(API_URL, {
      params: {
        pitchbook_id: pitchbookId
      },
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};

export const getInsights = async () => {
  try {
    const response = await axios.get(API_URL, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};
